import { render, staticRenderFns } from "./DashboardDiagramModule.vue?vue&type=template&id=4b8e4b73&scoped=true"
import script from "./DashboardDiagramModule.vue?vue&type=script&lang=js"
export * from "./DashboardDiagramModule.vue?vue&type=script&lang=js"
import style0 from "./DashboardDiagramModule.vue?vue&type=style&index=0&id=4b8e4b73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e4b73",
  null
  
)

export default component.exports